module.exports = "<div class=\"ug-step-example-picture-1\"></div>\n"